import { NotificationProvider } from '@ctn/ui/components/ctn-notifications';
import { BrowserRouter } from 'react-router-dom';

import KlaroCookies from './components/KlaroCookies';
import { HOMEPAGE } from './constants/routes.constants';
import { DirtyProvider } from './context/dirtyForm.context';
import { GlobalContextProvider } from './context/global.context';
import { PageProvider } from './context/page.context';
import Routes from './routes/Routes';

import '@ctn/ui/components/ctn-styles/styles.scss';
import './assets/themes/theme.scss';
import './styles/styles.scss';

function App() {
	return (
		<BrowserRouter basename={HOMEPAGE}>
			<KlaroCookies>
				<NotificationProvider>
					<DirtyProvider>
						<GlobalContextProvider>
							<PageProvider>
								<Routes />
							</PageProvider>
						</GlobalContextProvider>
					</DirtyProvider>
				</NotificationProvider>
			</KlaroCookies>
		</BrowserRouter>
	);
}

export default App;
